import { createContext } from "react";
import type { RestaurantType } from "src/business/restaurant/restaurant";
import type { RestaurantSummary } from "src/data/admin/types/organization";

const defaultRestaurantContext = {
  isLoading: true,
  loaded: false,
  restaurants: [],
  unsubscribedRestaurants: [],
  unsubscribedRestaurantsLoading: false,
  refetch: () => {},
};

interface RestaurantContextType {
  isLoading: boolean;
  /**
   * Whether the restaurant list has answered. An empty `restaurants` only means
   * the account manages none once this is true — before that it means nothing
   * has come back yet.
   */
  loaded: boolean;
  restaurants: RestaurantType[];
  /**
   * The organization's restaurants left out of `restaurants`: unsubscribing keeps
   * the organization link but drops the restaurant out of the subscribed list, and
   * its owner still has a payment history to read and a subscription to pay for.
   * Populated only when `restaurants` is empty and the caller owns the
   * organization; empty otherwise.
   */
  unsubscribedRestaurants: RestaurantSummary[];
  /** Whether that lookup is still in flight. */
  unsubscribedRestaurantsLoading: boolean;
  refetch: () => void;
}

export const RestaurantContext = createContext<RestaurantContextType>(
  defaultRestaurantContext
);
